import styled from "styled-components";
import DOMPurify from "dompurify";
import { palette } from "../../utils/theme";

const Content = styled.p`
  line-height: 18px;
  width: 100%;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  counter-reset: list;
  margin: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  color: ${palette.black};

  a {
    color: #075ff7;
    text-decoration: underline;
  }

  p {
    margin-top: 1em;
    margin-bottom: 1em;
    margin-left: 0;
    margin-right: 0;
  }

  // Remove any top white-space, preventing double spacing
  & > p:first-of-type {
    margin-top: 0;
  }

  // Remove any bottom white-space, preventing double spacing
  & > p:last-of-type {
    margin-bottom: 0;
  }

  & > ol,
  & > ul {
    list-style: none;
    display: block;
    padding-inline-start: 0px;
    padding-left: 36px;
  }

  & > ol > li {
    counter-increment: list;
  }

  ul {
    list-style-type: disc;
  }

  ul ul {
    list-style-type: circle;
  }

  & > ol > li::before {
    content: counter(list);
    width: 20px;
    height: 20px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    color: #3a3a3a;
    background: #f4f4f4;
    font-weight: bold;
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
    margin-left: -36px;
  }

  // Remove any top white-space, preventing double spacing
  li:first-child {
    margin-top: 0;
    padding-top: 0;
  }

  // Remove any bottom white-space, preventing double spacing
  li:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }

  unreset ol and li to default chrome user_agent_stylesheet ol ul,
  ul ol,
  ul ul,
  ol ol {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  ul ul,
  ol ul {
    list-style-type: circle;
  }

  ol ol ul,
  ol ul ul,
  ul ol ul,
  ul ul ul {
    list-style-type: square;
  }

  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }

  ol > li {
    margin-bottom: 16px;
  }

  ul li {
    margin-bottom: 8px;
  }

  ol ol,
  ul ul,
  ol ul,
  ul ol {
    margin-left: 36px;
  }

  ol ol,
  ol ul,
  ul ol,
  ul ul {
    margin-top: 16px;
  }
`;

const StyledInstructionBox = styled.div`
  &::-webkit-scrollbar {
    width: 4px;
  }
  overflow-wrap: break-word;
  &::-webkit-scrollbar-thumb {
    background: #c5c7cd;
    border-radius: 2px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 2px;
  }
`;
interface Props {
  description: string;
  isInstructionsExpanded?: boolean;
  scrollHeight?: number;
}

const AuthenticationInstructions = ({ description }: Props) => {
  return (
    <StyledInstructionBox className="min-h-0 overflow-auto p-[10px] border-gray-10 border rounded-lg mb-4 mx-5">
      {
        <Content
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(description),
          }}
        />
      }
    </StyledInstructionBox>
  );
};

export default AuthenticationInstructions;
